
export default function (Component) {
  Component.options.__source = "src/components/modifyPassword/index.vue"
}
